<template>
  <GameLayout
    class="d-flex align-center flex-column pattern fill-width text-center"
    score=" "
    @close="$track('close_tutorial', gameName)"
  >
    <h1>{{ $t(title) }}</h1>

    <div class="cards-container my-4 d-flex justify-center custom-elevation">

      <TutorialCard
        :image="cards[current].image"
      >
        {{ $t(cards[current].text) }}
        <TutorialForm
          v-if="cards[current].form"
          :questions="cards[current].form"
          @complete="formCompleted()"
        />
      </TutorialCard>

    </div>

    <TutorialNavigation
      v-if="!isLastCard"
      :cards="cards"
      :current="current"
      @prev="prev()"
      @next="next()"
    />
    <div v-else>
      <v-btn
        block
        rounded
        large
        color="primary"
        class="my-4"
        :disabled="isButtonDisabled"
        @click="play()"
      >
        {{ $t('GAME.START_GAME') }}
      </v-btn>
    </div>
  </GameLayout>
</template>

<style scoped>
.cards-container {
  height: 60vh;
  max-height: 500px;
  max-width: 340px;
  width: 90vw;
}
</style>

<script>
import GameLayout from '@/layouts/GameLayout.vue';

import TutorialCard from '@/components/games/tutorial/TutorialCard.vue';
import TutorialForm from '@/components/games/tutorial/TutorialForm.vue';
import TutorialNavigation from '@/components/games/tutorial/TutorialNavigation.vue';

export default {
  name: 'QuizTutorial',
  components: {
    GameLayout,
    TutorialCard,
    TutorialForm,
    TutorialNavigation,
  },
  props: {
    title: {
      type: String,
      default: 'GAME.HOW_TO_PLAY',
    },
    game: {
      type: String,
      default: '',
    },
    cards: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    current: 0,
    formAnswered: false,
  }),
  computed: {
    isLastCard() {
      return this.current === (this.cards.length - 1);
    },
    isButtonDisabled() {
      const card = this.cards[this.cards.length - 1];
      return card.form && !this.formAnswered;
    },
    gameName() {
      return this.$route.name.replace('Tutorial', '');
    },
  },
  methods: {
    prev() {
      this.current -= 1;
    },
    next() {
      this.current += 1;
    },
    formCompleted() {
      this.formAnswered = true;
      this.$track('pre_eval_complete', this.gameName);
    },
    preEvaluated() {
      const settings = {};
      let { game } = this;
      game = game.charAt(0).toUpperCase() + game.slice(1);
      if (game === 'Cards') {
        game = 'Tinder';
      }
      settings[`preEvaluated${game}`] = true;

      this.$store.dispatch('settings/store', settings);
    },
    play() {
      this.$emit('play');
      this.$store.dispatch('tutorial/firstPlay', this.game);
      this.preEvaluated();
      this.$router.replace({ name: this.game });
    },
  },
};
</script>
